import template from "./template_crud";
const vlm = '/vlm'
export const getVlm = template.getList(vlm);
export const addVlmFile = template.addOne(vlm + '/file')
export const getVlmById = template.getById(vlm)
export const startVlmById = template.updById(vlm, '/start')
export const saveVlmById = template.updById(vlm, '/save')
export const deleteVlmById = template.deleteById(vlm)
